import { addTrailingNewLine } from "./addTrailingNewLine.js";
function addLine(line, state) {
  return addTrailingNewLine(state) + line;
}
export {
  addLine
};
//# sourceMappingURL=addLine.js.map
